import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import * as actions from "./actions"
import BookmarkButton from "./components/BookmarkButton"
import { Labels } from "../../util/Translations"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    startCNIBookmarkButton: (
        element: HTMLElement | undefined | null,
        selectedListId: number | null,
        parentItemId: number | null,
    ) => void
    removeCNIBookmarkButton: () => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const bookmarkButtonId = "CNI_BOOKMARK_BUTTON"

    const startCNIBookmarkButton = (
        element: HTMLElement | undefined | null,
        selectedListId: number | null,
        parentItemId: number | null,
    ): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        let url
        if (!parentItemId) {
            url = `#cni_${selectedListId}`
        } else {
            url = `#cni_${parentItemId}_${selectedListId}`
        }

        store.dispatch(actions.initializeBookmarks())
        store.dispatch(
            actions.initializeBookmarkButton(
                bookmarkButtonId,
                null,
                "CNI",
                selectedListId,
                null,
                parentItemId,
                url,
            ),
        )

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <OldUIContext.Consumer>
                        {(): JSX.Element => {
                            const { RemoveBookmark, AddBookmark } = Labels
                            return (
                                <BookmarkButton
                                    addBookmarkLabel={AddBookmark}
                                    removeBookmarkLabel={RemoveBookmark}
                                    bookmarkButtonId={bookmarkButtonId}
                                />
                            )
                        }}
                    </OldUIContext.Consumer>
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    const removeCNIBookmarkButton = (): void => {
        store.dispatch(actions.removeBookmarkButton(bookmarkButtonId))
    }

    return {
        startCNIBookmarkButton,
        removeCNIBookmarkButton,
    }
}

export default init
